import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import css from './IconSocialMediaInstagram.module.css';

const IconSocialMediaInstagram = props => {
  const { rootClassName, className } = props;
  const classes = classNames(rootClassName || css.root, className);
  return (
    <svg
      className={classes}
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
    >
      <path
        fill="#E32922"
        fillRule="evenodd"
        d="M8.224 1.672c-1.125 0-3.535-.09-4.55.311-.352.14-.613.312-.884.583a2.466 2.466 0 00-.583.884c-.401 1.014-.31 3.425-.31 4.55s-.091 3.536.31 4.55c.141.352.312.613.583.884.271.271.532.442.884.583 1.015.401 3.425.311 4.55.311s3.536.09 4.55-.311c.352-.141.613-.312.884-.583.272-.271.442-.532.583-.884.402-1.014.311-3.425.311-4.55s.09-3.536-.311-4.55a2.466 2.466 0 00-.583-.884 2.467 2.467 0 00-.883-.583c-1.015-.402-3.426-.311-4.55-.311z"
        clipRule="evenodd"
      ></path>
      <path
        fill="#E32922"
        fillRule="evenodd"
        d="M15.938 8c0 1.065.01 2.12-.05 3.184-.06 1.236-.342 2.33-1.246 3.235-.904.904-1.998 1.185-3.234 1.245-1.065.06-2.12.05-3.184.05-1.065 0-2.12.01-3.184-.05-1.236-.06-2.33-.341-3.235-1.245-.904-.905-1.185-2-1.245-3.235C.5 10.12.51 9.064.51 8c0-1.065-.01-2.12.05-3.184C.62 3.58.9 2.486 1.805 1.58 2.71.677 3.805.396 5.04.336c1.064-.06 2.12-.05 3.184-.05 1.065 0 2.12-.01 3.184.05 1.236.06 2.33.341 3.234 1.245.904.905 1.186 2 1.246 3.235.06 1.065.05 2.12.05 3.184z"
        clipRule="evenodd"
      ></path>
      <path
        className={css.white}
        fill="#fff"
        fillRule="evenodd"
        d="M12.182 8a3.953 3.953 0 01-3.958 3.958A3.952 3.952 0 014.267 8a3.952 3.952 0 013.957-3.958A3.952 3.952 0 0112.182 8z"
        clipRule="evenodd"
      ></path>
      <path
        fill="#E32922"
        fillRule="evenodd"
        d="M10.795 8A2.576 2.576 0 008.224 5.43 2.576 2.576 0 005.653 8a2.576 2.576 0 002.571 2.572A2.576 2.576 0 0010.795 8z"
        clipRule="evenodd"
      ></path>
      <path
        className={css.white}
        fill="#fff"
        fillRule="evenodd"
        d="M13.266 3.882a.922.922 0 01-.924.924.922.922 0 01-.924-.924c0-.513.412-.925.924-.925s.924.412.924.925z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
};

IconSocialMediaInstagram.defaultProps = { rootClassName: null, className: null };

const { string } = PropTypes;

IconSocialMediaInstagram.propTypes = { rootClassName: string, className: string };

export default IconSocialMediaInstagram;
